
<template>

	<mymodal ref="modal" title="Сохранить фильтр" ok="Сохранить" :reset="reset" :submit="submit" :ok_disabled="index == null">

		<b-form-group label="Наименование">

			<v-select taggable :options="options" v-model="index" v-on:option:created="create" :reduce="obj => obj.index"
				:selectable="(option) => !option.not_editable"
				appendToBody appendToParent
			/>

		</b-form-group>

		<slot name="additional_controls"/>

	</mymodal>

</template>

<script>

import api from "../../api"
import mymodal from "../widgets/modal"

export default
{
	props :
	{
		essence : String,
	},

	components :
	{
		mymodal,
	},

	data()
	{
		return {
			
			index : null,
			options : [],

		}
	},

	methods :
	{
		reset()
		{
			this.index = null
			this.options = []

			this.$emit("reset")

			var query

			if(this.essence == "cadastral_objects" || this.essence == "cadastral_analogues")
				query = { "$or" : [ { essence : "cadastral_objects" }, { essence : "cadastral_analogues" } ] }
			else
				query = { essence : this.essence }

			api.call(this, "filters", "get_many", { query : query }, 
				response =>
				{
					var counter = 0

					var not_editable_date = Date.parse("2024-01-14") //TODO

					response.data.forEach(
						elem =>
						{
							this.options.push({ label : elem.name, index : counter,
								not_editable : this.$root.not_editable && (not_editable_date >= Date.parse(elem.add_date))
							})

							counter++
						})
				})
		},

		execute()
		{
			this.$refs.modal.execute()
		},

		submit()
		{
			const name = this.options.find(elem => elem.index == this.index).label

			this.$emit("save", { name : name })

			return new Promise(resolve => resolve(false)) // hide делает родительская компонента, чтобы не закрывать окно сохранения при возникновении вопросов
		},

		create(value)
		{
			const index = this.options.length
			const label = value.label == null ? value : value.label

			this.options.push({ label : label, index : index })

			this.$nextTick(() => { this.index = index })
		},
	}
}

</script>

